import {
  type ApplyWorkflowNodePayload,
  type EngineStateBase,
} from '@blaze-runtime/engine-data-access';
import { type WorkflowNodeId } from '@blaze-shared/api-contracts-domain';
import { type Workflow } from '@blaze-shared/workflow-domain';

export interface NodeExecutionDebugInfo {
  nodeId: WorkflowNodeId;
  prevNodeId?: WorkflowNodeId;
  nodePayload: ApplyWorkflowNodePayload;
}

export interface WorkflowDebuggerBreakpoint {
  breakOnNode?: WorkflowNodeId | null;
  stepInto?: WorkflowNodeId | null;
  stepOver?: WorkflowNodeId | null;
}

export interface WorkflowDebuggerState {
  busy?: boolean;

  breakpoint: WorkflowDebuggerBreakpoint;

  inProgress?: boolean;

  pendingNodeId?: string | null;
  executedNodeId?: string | null;
  resumeToken?: string;

  workflowId?: string;
  workflow?: Workflow;

  executionId?: string;
  contextData?: unknown;
  nodeExecutionHistory?: Array<NodeExecutionDebugInfo>;
  queuedStepPayload?: ApplyWorkflowNodePayload;
}

/** The field this library adds to the `engine` slice while stepping through a workflow. */
export interface WorkflowDebuggerSlice {
  workflowDebugger: WorkflowDebuggerState;
}

/**
 * The engine slice as the debugger handlers write it. `workflowDebugger` is absent unless this
 * library's engine-state extension is registered — a published runtime never steps a workflow.
 */
export type WorkflowDebuggerEngineState = EngineStateBase & Partial<WorkflowDebuggerSlice>;

export const initialWorkflowDebuggerSlice: WorkflowDebuggerSlice = {
  workflowDebugger: {
    breakpoint: {},
  },
};
